import * as cn from "classnames";
import * as React from "react";
import { ContentLoadBlockComponent } from "./ContentLoadBlock";
import "./UsersTable.css";
import { SvgIcon } from "./SvgIcon";
import { Triangle, SvgIconDeleteOff } from "@icons";
import { UserAccountInfo } from "@store";

export interface UsersTableComponentProps {
    users: UserAccountInfo[];
    loadingUsers: boolean;
    items: number;
    selectedIndex: number;
    onPageChange: (page: number) => void;
    onSort: (sortUrl: string) => void;
    onDelete: (userId: string) => void;
}

export interface UsersTableComponentState {
    currentSort: {
        name: string;
        sortType: "desc" | "asc";
    };
}

export class UsersTableComponent extends React.Component<UsersTableComponentProps, UsersTableComponentState> {
    constructor(props: UsersTableComponentProps) {
        super(props);
        this.state = {
            currentSort: {
                name: undefined,
                sortType: undefined
            }
        };
    }

    async handleSort(colSortUrl: string, colName: string) {
        if (this.state.currentSort.name === colName) {
            await this.setState({
                ...this.state,
                currentSort: {
                    ...this.state.currentSort,
                    sortType: this.state.currentSort.sortType === "desc" ? "asc" : "desc"
                }
            });
        } else {
            await this.setState({
                ...this.state,
                currentSort: {
                    ...this.state.currentSort,
                    name: colName,
                    sortType: "desc"
                }
            });
        }

        this.props.onSort(`${colSortUrl} ${this.state.currentSort.sortType}`);
    }

    renderRow(user: UserAccountInfo, index: number) {
        const { onDelete } = this.props;

        return (
            <tr
                className={cn("users-table__row", user && user.root === true ? "users-table__root-row" : "")}
                key={index}
            >
                <td className="users-table__column">{user && user.email}</td>
                <td className="users-table__column">{user && user.root === true ? "Root" : "User"}</td>
                <td className="users-table__column_last">
                    {user && user.root === true ? (
                        "(Can not be deleted)"
                    ) : (
                        <span className={cn("users-table__delete-icon")} onClick={() => onDelete(user["user-id"])}>
                            <SvgIcon svg={SvgIconDeleteOff} />
                        </span>
                    )}
                </td>
            </tr>
        );
    }

    render() {
        const { users, loadingUsers, onPageChange } = this.props;
        let { items, selectedIndex } = this.props;
        let pages = users && Math.ceil(users.length / items);
        return (
            <>
                <table className="users-table">
                    <thead>
                        <tr className="users-table__title-row">
                            <th
                                className={cn(
                                    "users-table__column-title users-table__column-title_clickable",
                                    this.state.currentSort.sortType === "desc" ? "active" : ""
                                )}
                                onClick={e => this.handleSort("email", "Email")}
                            >
                                Email <span className="sort-icon">&#10095;</span>
                            </th>
                            <th className="users-table__column-title">Type</th>
                            <th className="users-table__column-title" />
                        </tr>
                    </thead>
                    <tbody>
                        <ContentLoadBlockComponent loading={loadingUsers}>
                            {users && users.length > 0 ? (
                                users
                                    .slice(selectedIndex * items, (selectedIndex + 1) * items)
                                    .map((el: UserAccountInfo, index: number) => this.renderRow(el, index))
                            ) : (
                                <tr className="">
                                    <td
                                        className="users-table__no-users-column"
                                        colSpan={3}
                                        style={{ fontSize: "1rem" }}
                                    >
                                        There are no users!
                                    </td>
                                </tr>
                            )}
                        </ContentLoadBlockComponent>
                    </tbody>
                </table>
                <div className="pagination">
                    {pages > 1 &&
                        (() => {
                            const Items = [];
                            Items.push(
                                <div key="uniq-1">
                                    <button
                                        className={
                                            "pagination--switch" +
                                            (0 === selectedIndex ? " pagination--switch-isActive" : "")
                                        }
                                        onClick={() => onPageChange(1)}
                                        key={"first"}
                                    >
                                        First
                                    </button>

                                    <button
                                        onClick={() => onPageChange(selectedIndex)}
                                        disabled={0 === selectedIndex}
                                        className="Paginator__arrows page-prev"
                                        key={"left-arrow"}
                                    >
                                        <SvgIcon svg={Triangle} />
                                    </button>
                                </div>
                            );
                            for (let i = 0; i < pages; i++) {
                                Items.push(
                                    <button
                                        className={
                                            "pagination--switch" +
                                            (i == selectedIndex ? " pagination--switch-isActive" : "")
                                        }
                                        onClick={() => onPageChange(i + 1)}
                                        key={`pagination--switch-${i}`}
                                    >
                                        {i + 1}
                                    </button>
                                );
                            }
                            Items.push(
                                <div key="uniq-2">
                                    <button
                                        onClick={() => onPageChange(selectedIndex + 2)}
                                        disabled={pages - 1 === selectedIndex}
                                        className="Paginator__arrows page-next"
                                        // key={`last-${pages}`}
                                    >
                                        <SvgIcon svg={Triangle} />
                                    </button>

                                    <button
                                        className={
                                            "pagination--switch" +
                                            (pages - 1 === selectedIndex ? " pagination--switch-isActive" : "")
                                        }
                                        onClick={() => onPageChange(pages)}
                                        // key={`right-arrow-${pages}`}
                                    >
                                        Last
                                    </button>
                                </div>
                            );

                            return Items;
                        })()}
                </div>
            </>
        );
    }
}
